import React from 'react';
import PropTypes from 'prop-types';
import { renderImage, CHANNEL_LOGO_BANNER } from 'helpers/ImageHelper';

const ChannelBanner = ({ breakpoint, headline, logo, theme }) => (
  <div className={theme.channelBanner}>
    {renderImage({
      alt: headline,
      breakpoint,
      imageType: CHANNEL_LOGO_BANNER,
      src: logo,
    })}
  </div>
);

export default ChannelBanner;

ChannelBanner.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  headline: PropTypes.string,
  logo: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    channelBanner: PropTypes.string,
  }).isRequired,
};
